<template>
  <li class="side-menu-list__item">
    <a href="#" class="side-menu-list__icon" :class="icon" v-on:click.prevent="toggle"></a>
    <div class="sidebar" v-if="active">
      <div class="sidebar__block">
        <p class="sidebar__title">Ricoh Portal Applications:</p>
        <ul class="portal-list">
          <li v-for="portal in portals">
            <a :href="portal.Url" target="_blank">{{portal.Name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="active" class="side-menu-closer" v-on:click.prevent="toggle">
    </div>
  </li>
</template>
<script>
  import { getResource } from "../../../vuex/helpers";

  export default {
    vuex: {
      getters: {
        scroll: state => state.scrolled,
        portals: state => state.menu.portals,
        menuItem: state => state.menuItem,
        sidebarActive: state => state.sidebarActive
      },
      actions: { getResource }
    },
    computed: {
      active () {
        return this.menuItem === this._uid;
      },
      icon () {
        var icon = (this.$route.path === "/" && !this.scroll) ? "icon-portal-white" : "icon-portal";
        icon += (this.sidebarActive && !this.active) ? " icon--disabled" : "";
        return icon;
      }
    },
    methods: {
      toggle () {
        this.$dispatch("submenu_clicked", this._uid, true);
      }
    }
  };
</script>
<style lang="scss">
  @import '../../../assets/scss/variables.scss';
  @import '../../../assets/scss/mixins.scss';

  .portal-list{
    list-style: none;
    padding: 0;
    margin: 0;

    li{
      padding-top: 12px;
    }

    a{
      color: $green_light;
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarPortal.vue?4e6a2cb3